<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-project-lead-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Project Lead
            </h4>
          </div>

          <div class="modal-body">
            <TypeaheadFormGroup
                v-model="data.project_id"
                name="project_id"
                label="Project"
                endpoint="/api/v2/projects"
                :params="{'filter[status]': 'active'}"
                :token="shared.token"
                :error="getError('project_id') || getError('company_id')"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    company:{
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {},

      shared: store,
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $('#create-project-lead-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/project-leads', {...this.data, company_id: this.company.id})
          .then(response => {
            notify.success('The project lead was saved')

            this.$emit('created', response.data.data)

            $('#create-project-lead-modal').modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
